import styled from "styled-components";

export const ResourceTabBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  height: calc(100vh - 60px);

  .custom_tablist {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
`;

export const DivTabWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  width: 50%;
  justify-content: center;

  .tab {
    width: 100%;
  }
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -4px;
`;

export const DivResourceListWrapper = styled.div<{ $height?: number, $theme?: string }>`
  height: ${(props) => props.$height || "30"}px;
  transition: all 0.3s ease-out;
`;
